const MS_PER_SECOND = 1000

/**
 * Extract the expiration timestamp from a JWT without a library.
 *
 * A JWT has three base64-encoded parts: header.payload.signature.
 * The payload contains an `exp` field — seconds since Unix epoch (per RFC 7519).
 * We convert it to milliseconds so it can be compared directly with `Date.now()`.
 *
 * Returns `null` if the token is malformed or has no `exp` claim.
 */
export function decodeJwtExp(token: string): number | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))

    return payload.exp ? payload.exp * MS_PER_SECOND : null
  } catch {
    return null
  }
}

export function createAuthChannel(): BroadcastChannel | null {
  if (typeof window !== 'undefined' && typeof BroadcastChannel !== 'undefined') {
    return new BroadcastChannel('auth')
  }

  return null
}

/** Shared singleton — use this to broadcast auth events from anywhere in the app */
export const authChannel = createAuthChannel()
